import React from "react";
import "./About_Content.css";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";

const About_Content = () => {
  return (
    <section className="About_Content">
      <div className="container">
        {/* <Common_Title_2 titleText={"About Us"} /> */}

        <div className="content_div">
          <div className="row align-items-center about_row justify-content-center">
            <div className="col-md-6 col-10  mb-4 mb-lg-0">
              <div className="left_img_div">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/about_us/about_content/about_section_img.png"
                  }
                  className="inner_img"
                  alt="About Nutricos"
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="inner_div">
                <h2>Seedso was built on a simple belief</h2>

                <div className="quote_box">
                  Better fertilizer create better harvests.
                </div>

                <p>
                  Every successful crop begins with the right seed. At Seedso,
                  we are committed to providing farmers with high-quality seeds
                  that deliver strong germination, healthy growth, and higher
                  yields.
                </p>

                <ul className="points_list">
                  <li>Premium quality seeds with high germination rates</li>
                  <li>Scientifically tested for consistent crop performance</li>
                  <li>
                    Suitable for diverse soil types and climatic conditions
                  </li>
                </ul>

                <p>
                  We believe agriculture grows stronger when farmers have access
                  to reliable, high-performing seeds backed by quality and
                  trust.
                </p>

                <p>
                  Whether you're cultivating vegetables, grains, pulses, or
                  specialty crops, Seedso supports every stage of your farming
                  journey with products designed for sustainable and profitable
                  agriculture.
                </p>

                <div className="goal_box">
                  <span>OUR MISSION</span>
                  <h4>
                    Empower farmers with trusted seeds that improve
                    productivity, promote sustainable farming, and contribute to
                    a greener future.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About_Content;
